export const inlineCodeSx = {
  fontFamily: 'var(--app-font-mono, ui-monospace, monospace)',
  fontSize: '0.875em',
  px: '4px',
  py: '2px',
  borderRadius: '4px',
  bgcolor: 'var(--app-bg-active)',
}
